import * as React from "react";
import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { createOrUpdateShape } from "orion-components/GlobalData/Actions";
import { useDispatch, useSelector } from "react-redux";
import EventBus from "orion-components/SharedComponents/EventBus";
import { getDir } from "orion-components/i18n/Config/selector";
import PropTypes from "prop-types";

const CustomizedTextField = styled(TextField)({
	"& label": {
		color: "#9A9FA3",
		fontSize: 10
	},
	"& label.Mui-focused": {
		color: "#9A9FA3"
	},
	"& .MuiOutlinedInput-root": {
		fontSize: 10,
		color: "#FFFFFF",
		fontFamily: "Roboto",
		width: 64,
		height: 32,
		"& fieldset": {
			borderColor: "#5E6571"
		},
		"&:hover fieldset": {
			borderColor: "#4DB5F4"
		},
		"&.Mui-focused fieldset": {
			borderColor: "#4DB5F4"
		}
	}
});
let lineStrokeOpacity = null;
let polyFillOpacity = null;

export default function TransparencySlider({ shapeType, isForFill }) {
	const [value, setValue] = React.useState(isForFill ? 10 : 100);
	const dispatch = useDispatch();
	const shapesReducer = useSelector((state) => state.shapes);
	const dir = useSelector((state) => getDir(state));

	React.useEffect(() => {
		if (isForFill) {
			if (shapesReducer[shapeType]?.polyFillOpacity) {
				if (!isNaN(shapesReducer[shapeType].polyFillOpacity)) {
					polyFillOpacity = shapesReducer[shapeType].polyFillOpacity;
				} else {
					polyFillOpacity = 100;
				}
			}
			setValue(polyFillOpacity);
			EventBus.publish("drawUpdateStyles", {
				...shapesReducer[shapeType],
				polyFillOpacity: polyFillOpacity
			});
		} else {
			if (shapesReducer[shapeType]?.lineStrokeOpacity) {
				if (!isNaN(shapesReducer[shapeType].lineStrokeOpacity)) {
					lineStrokeOpacity = shapesReducer[shapeType].lineStrokeOpacity;
				} else {
					lineStrokeOpacity = 100;
				}
			} else {
				//Shapes that were created using the old shape editor do not have a line stroke opacity property. To avoid displaying its value as NaN, we are setting it to the default line stroke value of 100
				lineStrokeOpacity = 100;
			}

			setValue(lineStrokeOpacity);

			EventBus.publish("drawUpdateStyles", {
				...shapesReducer[shapeType],
				lineStrokeOpacity: lineStrokeOpacity
			});
		}
	}, []);

	const handleSliderChange = (event, newValue) => {
		if (isForFill) {
			dispatch(createOrUpdateShape(shapeType, { polyFillOpacity: newValue }));
			EventBus.publish("drawUpdateStyles", { ...shapesReducer[shapeType], polyFillOpacity: newValue });
		} else {
			dispatch(createOrUpdateShape(shapeType, { ...shapesReducer[shapeType], lineStrokeOpacity: newValue }));
			EventBus.publish("drawUpdateStyles", { ...shapesReducer[shapeType], lineStrokeOpacity: newValue });
		}
		setValue(newValue);
	};

	const handleInputChange = (event) => {
		const trans = event.target.value === "" ? "" : Number(event.target.value);
		if (isForFill) {
			dispatch(createOrUpdateShape(shapeType, { polyFillOpacity: trans }));
			EventBus.publish("drawUpdateStyles", { ...shapesReducer[shapeType], polyFillOpacity: trans });
		} else {
			dispatch(createOrUpdateShape(shapeType, { lineStrokeOpacity: trans }));
			EventBus.publish("drawUpdateStyles", { ...shapesReducer[shapeType], lineStrokeOpacity: trans });
		}

		setValue(trans);
	};

	const handleBlur = () => {
		if (value < 0) {
			setValue(0);
		} else if (value > 100) {
			setValue(100);
		}
	};

	return (
		<div style={{ display: "flex", marginBottom: 14 }}>
			<div
				style={{
					width: 159,
					height: 23,
					...(dir === "ltr" && { marginRight: 15 }),
					...(dir === "rtl" && { marginLeft: 15 })
				}}
			>
				<Slider
					value={typeof value === "number" ? value : 0}
					onChange={handleSliderChange}
					aria-labelledby="input-slider"
				/>
			</div>
			<div>
				<CustomizedTextField
					variant="outlined"
					name="transparency"
					value={value}
					onChange={handleInputChange}
					onBlur={handleBlur}
					inputProps={{ style: { color: "#FFFFFF", fontSize: 10, fontFamily: "Roboto" } }}
					InputProps={{
						endAdornment: <InputAdornment position="end">%</InputAdornment>
					}}
				/>
			</div>
		</div>
	);
}

TransparencySlider.propTypes = {
	shapeType: PropTypes.string.isRequired,
	isForFill: PropTypes.bool.isRequired
};
